<template>
  <button
    :class="
      `px-5 py-3 text-sm font-bold leading-normal text-white rounded border outline-none cursor-pointer ${color}`
    "
    :type="type"
    @click="click"
  >
    <slot>Submit</slot>
  </button>
</template>

<script>
export default {
  name: 'AgButton',
  props: {
    type: {
      type: String,
      required: true
    },
    onClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    buttonType: {
      type: String,
      default: 'primary'
    },
    buttonColor: {
      type: String,
      default: 'blue',
      validator: function(value) {
        return ['blue', 'gray'].includes(value);
      }
    }
  },
  computed: {
    color() {
      return `bg-${this.buttonColor}-600`;
    }
  },
  methods: {
    click(e){
      this.$emit('onClick', e);
    }
  }
};
</script>
